<script setup lang="ts">
// Diamond token mark: a rounded square rotated -135° with a smaller rounded
// square centred inside it. Both the rotation and the radii come straight from
// the design's geometry, so this is reproduced rather than redrawn by eye.
interface Props {
  /** Outer diamond fill. */
  color?: string
  /** Inner pip fill. */
  pipColor?: string
  /** Rendered edge length in px. */
  size?: number
}

withDefaults(defineProps<Props>(), {
  color: 'var(--p-primary-600)',
  pipColor: 'var(--p-sliceal-neo-mint, #00bc89)',
  size: 26,
})
</script>

<template>
  <span class="tdi" :style="{ width: `${size}px`, height: `${size}px` }" aria-hidden="true">
    <span class="tdi__outer" :style="{ background: color }" />
    <span class="tdi__pip" :style="{ background: pipColor }" />
  </span>
</template>

<style scoped>
.tdi {
  position: relative;
  display: inline-block;
  flex-shrink: 0;
}

.tdi__outer,
.tdi__pip {
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  transform: translate(-50%, -50%) rotate(-135deg);
}

/* 30.335 / 42.9 and 8.273 / 42.9 from the design's own measurements. */
.tdi__outer {
  width: 70.7%;
  height: 70.7%;
  border-radius: 27%;
}

.tdi__pip {
  width: 19.3%;
  height: 19.3%;
  border-radius: 4.5%;
  border: 1px solid var(--p-surface-0);
  box-sizing: content-box;
}
</style>
